import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import GeoSearchInput from '../../components/geo-search-input';
import SearchMapContainer from '../../components/search-map-container';
import SmallCouncilList from '../../components/small-council-list';
import * as selectors from '../../reducers';
import styles from './search-page.module.scss';
import { setActiveCouncil, setActivePage } from '../../actions/ui';

class SearchPage extends Component {
  constructor() {
    super();
    this.selectCouncil = this.selectCouncil.bind(this);
    this.handleListClick = this.handleListClick.bind(this);
  }
  selectCouncil(councilId) {
    const { setActiveCouncil, setActivePage } = this.props;
    setActiveCouncil(councilId);
    setActivePage('council');
  }

  handleListClick(council) {
    return e => {
      window.scrollTo(0, 0);
      this.selectCouncil(council.id);
    };
  }

  renderCouncils() {
    const { councils } = this.props;
    return (
      <ul className={styles.councilList}>
        {councils.map((council, i) => (
          <li key={i} className={styles.councilListElement}>
            <button
              type="button"
              className={styles.councilListElementButton}
              onClick={this.handleListClick(council)}
            >
              {council.name}
            </button>
          </li>
        ))}
      </ul>
    );
  }
  render() {
    return (
      <div>
        <div className={styles.searchPageHeader}>
          <div className={styles.mainHeading}>Understanding your council</div>
          <hr className={styles.mainHeadingLine} />
          <div className={styles.subHeading}>
            Find your local council below to explore the financial audit data
            from 1 Jul 2018 to 30 Jun 2019 and compare to other councils. This
            interactive tool includes data on revenue, expenses, operating
            costs, assets, liabilities and sustainability indicators.
          </div>
        </div>
        <div className={styles.section}>
          <h3 className={styles.sectionHeading}>Search by map</h3>
          <div className={styles.searchWrapper}>
            <GeoSearchInput onCouncilSelect={this.selectCouncil} />
          </div>
          <div className={styles.mapRow}>
            <div className={styles.mapWrapper}>
              <SearchMapContainer onCouncilSelect={this.selectCouncil} />
            </div>
            <div className={styles.smallCouncilWrapper}>
              <h4 className={styles.smallerCouncilHeadline}>
                Smaller councils
              </h4>
              <p className={styles.smallerCouncilText}>Less than 1000km</p>
              <SmallCouncilList onClick={this.handleListClick} />
            </div>
          </div>
        </div>

        <div className={styles.section}>
          <h3 className={styles.sectionHeading}>Select from list</h3>
          <div className={styles.listWrapper}>{this.renderCouncils()}</div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  setActiveCouncil,
  setActivePage,
};

const mapStateToProps = state => ({
  councils: selectors.getCouncils(state),
});

SearchPage.propTypes = {
  councils: PropTypes.arrayOf(PropTypes.object),
  setActiveCouncil: PropTypes.func,
  setActivePage: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchPage);



// WEBPACK FOOTER //
// ./src/pages/search-page/search-page.js